export default __webpack_public_path__ + "static/media/Belicoso.64b87ebc.jpg";